import { SETTINGS_STORAGE_KEY } from './constants';

export const persistSettings = (settings: any) => (
  localStorage.setItem(SETTINGS_STORAGE_KEY, JSON.stringify(settings))
);
